import EntitlementService from 'src/modules/entitlement/entitlementService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'ENTITLEMENT_FORM';

const entitlementFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: entitlementFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await EntitlementService.find(id);
      }

      dispatch({
        type: entitlementFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: entitlementFormActions.INIT_ERROR,
      });

      getHistory().push('/entitlement');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: entitlementFormActions.CREATE_STARTED,
      });

      await EntitlementService.create(values);

      dispatch({
        type: entitlementFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.entitlement.create.success'),
      );

      getHistory().push('/entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: entitlementFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: entitlementFormActions.UPDATE_STARTED,
      });

      await EntitlementService.update(id, values);

      dispatch({
        type: entitlementFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.entitlement.update.success'),
      );

      getHistory().push('/entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: entitlementFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default entitlementFormActions;
